// extracted by mini-css-extract-plugin
export default {"wrapper":"OverviewFailureTable_wrapper__FJTCv","itemWrapper":"OverviewFailureTable_itemWrapper__pMbkj","indexWrapper":"OverviewFailureTable_indexWrapper__+tovi"};